import { render, staticRenderFns } from "./Mp3SoundViewer.vue?vue&type=template&id=166cc456&"
import script from "./Mp3SoundViewer.vue?vue&type=script&lang=js&"
export * from "./Mp3SoundViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports